import * as React from 'react';
import { connect } from 'react-redux';
import getDisplayName from 'recompose/getDisplayName';

import { GlobalState } from 'ha/types/store';
import { RouteShape } from './types';
import { getRouteData, getRoute } from './selectors';

export interface HermesProps<DataShape> {
  data: DataShape;
  route: RouteShape;
}

export function withHermes<DataShape, P extends HermesProps<DataShape>>(
  ComponentToWrap: React.ComponentType<P>,
) {
  const hoc: React.ComponentType<
    Omit<P, keyof HermesProps<DataShape>>
  > = connect((state: GlobalState) => ({
    data: getRouteData(state),
    route: getRoute(state),
    // @ts-ignore
  }))(ComponentToWrap);

  hoc.displayName = `withHermes(${getDisplayName(ComponentToWrap)})`;

  return hoc;
}
